import script from "./TestQuestionsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestQuestionsComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TestQuestionsComponent.vue?vue&type=style&index=0&id=fdb189ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb189ee"]])

export default __exports__